import React from "react";
import {
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const CustomBarChart = ({ data, report, setReportBody }) => {
  const colors = ['#8884d8', '#82ca9d', '#ffc658', '#ff7300', '#a4de6c', '#d0ed57', '#8dd1e1'];

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        width={500}
        height={300}
        data={data.barChartData}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        {data?.barChartKeys?.map((key, index) => (
          <Bar  key={key} dataKey={key} fill={colors[index % colors.length]}/>
        ))}
        {/* <Bar dataKey="2015" fill="#8884d8" />
        <Bar dataKey="2018" fill="#82ca9d" />
        <Bar dataKey="2021" fill="#ffc658" /> */}
      </BarChart>
    </ResponsiveContainer>
  );
};
export default CustomBarChart;
